import { render, staticRenderFns } from "./management-question-set-view.vue?vue&type=template&id=327a2ede&scoped=true"
import script from "./management-question-set-view.vue?vue&type=script&lang=js"
export * from "./management-question-set-view.vue?vue&type=script&lang=js"
import style0 from "./management-question-set-view.vue?vue&type=style&index=0&id=327a2ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327a2ede",
  null
  
)

export default component.exports